import { render, staticRenderFns } from "./CarInfoHeader.vue?vue&type=template&id=07907dc3&scoped=true&"
import script from "./CarInfoHeader.vue?vue&type=script&lang=js&"
export * from "./CarInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./CarInfoHeader.vue?vue&type=style&index=0&id=07907dc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07907dc3",
  null
  
)

export default component.exports